export const ACTIONS = {
  AUDIT_CASE_CREATE: 'audit-case-create',
  AUDIT_CASE_UPDATE: 'audit-case-update',
  AUDIT_CASE_DELETE: 'audit-case-delete',
  AUDIT_CASE_SUBMIT: 'audit-case-submit',
  AUDIT_CASES_LIST_VIEW: 'audit-case-list-view',
  AUDIT_CASE_DETAILS_VIEW: 'audit-case-details-view',
};
